import { Inject, Injectable } from '@angular/core';
import { HrConfigurationModel } from '../model/hr.configuration.model';
import { HvlConfigurationService } from '@hvlng/framework-bff/core';

@Injectable({
    providedIn: 'root',
})
export class HrConfigurationService {
    constructor(@Inject(HvlConfigurationService) private hvlConfigurationService: HvlConfigurationService) {}

    get config(): HrConfigurationModel {
        return this.hvlConfigurationService.config as any as HrConfigurationModel;
    }
}
